export const showIntercomNewMessage = () => {
  if ('Intercom' in window && typeof window.Intercom === 'function') {
    /** @type {typeof import('intercom-web')} */
    window.Intercom('showNewMessage');
  } else {
    console.error('Intercom is not loaded');
  }
};
